module.exports = __webpack_public_path__ + "favicon-192x192.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/favicon-192x192.png
// module id = 1816
// module chunks = 0